import React, { useEffect, useState } from 'react';

import { Field, Formik } from 'formik';

import { Modal } from 'components/Modal';
import { Button } from 'components/Button/Button';
import { DataLists } from 'services/data/data.types';
import { Datalist } from 'components/Datalist/Datalist';
import { User } from 'services/auth/auth.types';
import useCreateEventModalVM from './useCreateEventModalVM';
import { AddressAutocomplete } from 'components/Address/Address';
import { MultiSelect } from 'components/MultiSelect/MultiSelect';
import { AgendaEvent } from 'services/agenda/agenda.types';
import Select from 'react-select';
import { EventInteractionArgs } from 'react-big-calendar/lib/addons/dragAndDrop';
import { useSelector } from 'react-redux';
import { getUser } from 'features/auth/auth.slice';

import './CreateEventModal.scss';
import moment from 'moment';

export type CreateEventModalProps = {
    open: boolean;
    onValidate: (event: AgendaEvent) => void;
    createEventContent: Partial<AgendaEvent> | undefined;
    setClose: () => any;
    title: string;
    submitText: string;
    isValidateDestructive?: boolean;
    onChange: (key: string, val: string) => any;
    usersList: User[];
    eventCreationStep: number;
    setEventCreationStep: (step: number) => void;
    onEventCreated?: (event: AgendaEvent) => void;
    moveOrResizeEvent: ({ event, start, end }: EventInteractionArgs<any>) => Promise<void>;
};

const generateHourOptions = (length: number, start: number) => {
    
    return (<>
        {Array.from({ length }).map((_, index) => {
            const t = index + start;
            return (
                <option key={t} value={t.toString().padStart(2, '0')}>
                    {t.toString().padStart(2, '0')}
                </option>
            );
        })}
    </>)
}


const generateMinuteOptions = (length: number, start: number) => {
    
    return (<>
        {Array.from({ length }).map((_, index) => {
            const t = index * start;
            return (
                <option key={t} value={t.toString().padStart(2, '0')}>
                    {t.toString().padStart(2, '0')}
                </option>
            );
        })}
    </>)
}


export const CreateEventModal: React.FC<CreateEventModalProps> = ({
    open,
    onValidate,
    createEventContent,
    setClose,
    isValidateDestructive = false,
    usersList,
    eventCreationStep,
    setEventCreationStep,
    moveOrResizeEvent,
    onEventCreated
}) => {
    const { persons, partners, handleCreateEvent } = useCreateEventModalVM({
        onEventCreated
    });

    const user = useSelector(getUser);

    const stepIsValid = (step: number, values: any) => {
        if(step === 1){
            return values.event_type && values.label && values.created_by;
        }else if(step === 2){
            return values.start_at_date && values.end_at_date;
        }else if(step === 3){
            return true;
        }

        return false;
    }

    return (
        <Modal isValidateDestructive={isValidateDestructive} open={open} setClose={() => setClose && setClose()}>
            <>
                <Formik
                    initialValues={{
                        event_type: '',
                        label: '',
                        started_at: '',
                        start_at_date: '',
                        start_at_hour: '09',
                        start_at_minute: '00',

                        ended_at: '',
                        end_at_date: '',
                        end_at_hour: '18',
                        end_at_minute: '00',

                        address: {
                            address: '',
                            address_add: '',
                            city: '',
                            zipcode: '',
                            country: ''
                        },
                        emails_list: [],
                        stakeholders_list: [],
                        assistants_list: [],
                        partners_list: [],
                        observation: '',
                        created_by: createEventContent?.created_by_fullname && createEventContent?.created_by_id ? {label: createEventContent.created_by_fullname, value: createEventContent.created_by_id} : {
                            label: user?.fullname,
                            value: user?.id
                        },
                        person: createEventContent?.person_fullname && createEventContent?.person_id ? {label: createEventContent.person_fullname, value: createEventContent.person_id} : null,
                        ...createEventContent,
                    }}
                    enableReinitialize
                    onSubmit={async (values, { setSubmitting }) => {
                        if(values.id){
                            await moveOrResizeEvent({
                                event: values,
                                start: moment.tz(
                                    `${values.start_at_date}T${values.start_at_hour}:${values.start_at_minute}:00`,
                                    'Europe/Paris'
                                  ).toDate(),
                                end: moment.tz(
                                    `${values.end_at_date}T${values.end_at_hour}:${values.end_at_minute}:00`,
                                    'Europe/Paris'
                                  ).toDate(),
                            });


                        }else{
                            await handleCreateEvent({
                                ...values,
                                started_at: `${values.start_at_date}T${values.start_at_hour}:${values.start_at_minute}:00`,
                                ended_at: `${values.end_at_date}T${values.end_at_hour}:${values.end_at_minute}:00`,
                            });
                        }
                        setClose();
                        setSubmitting(false);
                    }}
                >
                    {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, isValidating, setFieldValue }) => {
                        return (
                            <form onSubmit={handleSubmit} className="form form-calendar">
                                <h2>
                                    Étape {eventCreationStep} / 3
                                </h2>
                                {eventCreationStep === 1 && (
                                    <>
                                        <div className="form-line">
                                            <div className="form-group react-custom-select-parent">
                                                <label>Organisateur*</label>
                                                <MultiSelect
                                                    name="created_by"
                                                    isMulti={false}
                                                    placeholder="Sélectionner un membre DAPV"
                                                    values={values.created_by}
                                                    update={(e: {label: string, value: string}) => {
                                                        setFieldValue('created_by', e);
                                                    }}
                                                    labelKey="fullname"
                                                    options={usersList}
                                                    colors={[]}
                                                />
                                        
                                                {errors.created_by && touched.created_by && (
                                                    <p className="error">{String(errors.created_by)}</p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="form-line">
                                            <div className="form-group">
                                                <label>Type de d'évènement*</label>
                                                <Datalist
                                                    list="event_types"
                                                    name="event_type"
                                                    required
                                                    placeholder="Sélectionner un type d'évènement"
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                        setFieldValue('event_type', e.target.value);
                                                    }}
                                                    onBlur={handleBlur}
                                                    value={values.event_type}
                                                />
                                                {errors.event_type && touched.event_type && errors.event_type}
                                            </div>
                                        </div>
                                        <div className="form-line">
                                            <div className="form-group">
                                                <label>Nom de l'évènement*</label>
                                                <input
                                                    type="text"
                                                    name="label"
                                                    required
                                                    placeholder="Nom de l'évènement"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.label}
                                                />
                                                {errors.label && touched.label && errors.label}
                                            </div>
                                        </div>
                                        <div className="form-line">
                                            <div className="form-group">
                                                <label>Commentaire</label>
                                                <textarea
                                                    name="observation"
                                                    placeholder="Commentaire"
                                                    rows={3}
                                                    className="textarea-observation"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.observation}
                                                />
                                                {errors.observation && touched.observation && (
                                                    <p className="error">{String(errors.observation)}</p>
                                                )}
                                            </div>
                                        </div>
                                    </>
                                )}
                                {eventCreationStep === 2 && (
                                    <>
                                        <div className="form-line">
                                            <div className="form-group">
                                                <label>Date de début*</label>
                                                <div className="datetime-inputs">
                                                    <input
                                                        type="date"
                                                        name="start_at_date"
                                                        placeholder="Date de début"
                                                        onChange={(e) => {
                                                            setFieldValue('start_at_date', e.target.value);
                                                        }}
                                                        onBlur={handleBlur}
                                                        value={values.start_at_date || ''}
                                                    />
                                                    <div className="time-selects">
                                                        <select
                                                            name="start_at_time_hour"
                                                            onChange={(e) => {
                                                                setFieldValue('start_at_hour', e.target.value);
                                                            }}
                                                            onBlur={handleBlur}
                                                            value={values.start_at_hour}
                                                        >
                                                            {generateHourOptions(15, 6)}
                                                        </select>
                                                        <select
                                                            name="start_at_time_minute"
                                                            onChange={(e) => {
                                                                setFieldValue('start_at_minute', e.target.value);
                                                            }}
                                                            onBlur={handleBlur}
                                                            value={values.start_at_minute}
                                                        >
                                                            {generateMinuteOptions(12, 5)}
                                                        </select>
                                                    </div>
                                                </div>
                                                {errors.started_at && touched.started_at && (
                                                    <p className="error">{String(errors.started_at)}</p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="form-line">
                                            <div className="form-group">
                                                <label>Date de fin*</label>
                                                <div className="datetime-inputs">
                                                    <input
                                                        type="date"
                                                        name="end_at_date"
                                                        placeholder="Date de fin"
                                                        min={values.start_at_date || undefined}
                                                        onChange={(e) => {
                                                            setFieldValue('end_at_date', e.target.value);
                                                        }}
                                                        onBlur={handleBlur}
                                                        value={values.end_at_date || ''}
                                                    />
                                                    <div className="time-selects">
                                                        <select
                                                            name="end_at_time_hour"
                                                            onChange={(e) => {
                                                                setFieldValue('end_at_hour', e.target.value);
                                                            }}
                                                            onBlur={handleBlur}
                                                            value={values.end_at_hour}
                                                        >
                                                            {generateHourOptions(15, 6)}
                                                        </select>
                                                        <select
                                                            name="end_at_time_minute"
                                                            onChange={(e) => {
                                                                setFieldValue('end_at_minute', e.target.value);
                                                            }}
                                                            onBlur={handleBlur}
                                                            value={values.end_at_minute}
                                                        >
                                                            {generateMinuteOptions(12, 5)}
                                                        </select>
                                                    </div>
                                                </div>
                                                {errors.ended_at && touched.ended_at && <p className="error">{String(errors.ended_at)}</p>}
                                            </div>
                                        </div>
                                        <div className="form-line">
                                            <div className="form-group">
                                                <label>Adresse postale</label>
                                                <div className="fields address">
                                                    <AddressAutocomplete
                                                        baseField="address"
                                                        formValue={values.address}
                                                        setValue={setFieldValue}
                                                    />
                                                </div>
                                                {errors.address && typeof errors.address === 'string' && (
                                                    <p className="error">{errors.address}</p>
                                                )}
                                            </div>
                                        </div>
                                    </>
                                )}
                                {eventCreationStep === 3 && (
                                    <>
                                        {persons.length > 0 && (
                                            <div className="form-line">
                                                <div className="form-group">
                                                    <label>Personne soutenue</label>
                                                    <MultiSelect
                                                        name="person"
                                                        isMulti={false}
                                                        placeholder="Sélectionner une personne"
                                                        values={values.person}
                                                        update={(e: {label: string, value: string}) => {
                                                            setFieldValue('person', e);
                                                            setFieldValue('stakeholders_list', []);
                                                        }}
                                                        labelKey="fullname"
                                                        options={persons}
                                                        colors={[]}
                                                    />
                                            
                                                    {errors.person && touched.person && (
                                                        <p className="error">{String(errors.person)}</p>
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                        {values.person && (
                                            <div className="form-line">
                                                <div className="form-group">
                                                    <label>Proche(s)</label>
                                                    <MultiSelect
                                                        name="stakeholders_list"
                                                        placeholder="Selectionner des personnes"
                                                        values={values.stakeholders_list}
                                                        labelKey="fullname"
                                                        update={(e: string[]) => {
                                                            setFieldValue('stakeholders_list', e);
                                                        }}
                                                        options={persons.find((person) => values.person && person.id === Number(values.person.value))?.stakeholders || []}
                                                        colors={[]}
                                                    />
                                                    {errors.stakeholders_list && touched.stakeholders_list && (
                                                        <p className="error">{String(errors.stakeholders_list)}</p>
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                        {usersList.length > 0 && (
                                            <div className="form-line">
                                                <div className="form-group">
                                                    <label>Membre(s) DAPV</label>
                                                    <MultiSelect
                                                        name="assistants_list"
                                                        placeholder="Selectionner des membres DAPV"
                                                        values={values.assistants_list}
                                                        labelKey="fullname"
                                                        update={(e: string[]) => {
                                                            setFieldValue('assistants_list', e);
                                                        }}
                                                        options={usersList.filter((u) => u.id !== user?.id)}
                                                        colors={[]}
                                                    />
                                                    {errors.assistants_list && touched.assistants_list && (
                                                        <p className="error">{String(errors.assistants_list)}</p>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                        {partners.length > 0 && (
                                            <div className="form-line">
                                                <div className="form-group">
                                                    <label>Partenaire(s)</label>
                                                    <MultiSelect
                                                        name="partners_list"
                                                        placeholder="Selectionner des partenaires"
                                                        values={values.partners_list}
                                                        labelKey="department_name"
                                                        update={(e: string[]) => {
                                                            setFieldValue('partners_list', e);
                                                        }}
                                                        options={partners}
                                                        colors={[]}
                                                    />
                                                    {errors.partners_list && touched.partners_list && (
                                                        <p className="error">{String(errors.partners_list)}</p>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                        <div className="form-line">
                                            <div className="form-group">
                                                <label>Emails invités</label>
                                                <MultiSelect
                                                    name="emails"
                                                    labelKey={'label'}
                                                    valueKey={'value'}
                                                    placeholder="Saisir des emails"
                                                    values={values.emails_list}
                                                    update={(e: string[]) => {
                                                        setFieldValue('emails_list', e);
                                                    }}
                                                    creatable={true}
                                                    options={[]}
                                                    colors={[]}
                                                />
                                            </div>
                                        </div>
                                    </>
                                )}

                                <div className="actions-buttons">

                                    {eventCreationStep > 1 && (
                                        <Button
                                            label="Précédent"
                                            variant="dark"
                                            type="button"
                                            disabled={isSubmitting}
                                            className="previous-step-button"
                                            onClick={() => setEventCreationStep(eventCreationStep - 1)}
                                        />
                                    )}

                                    {eventCreationStep < 3 && (
                                        <Button
                                            label="Suivant"
                                            variant="dark"
                                            type="button"
                                            disabled={isSubmitting || !stepIsValid(eventCreationStep, values)}
                                            className="next-step-button"
                                            onClick={() => setEventCreationStep(eventCreationStep + 1)}
                                        />
                                    )}

                                    {eventCreationStep === 3 && (
                                        <Button
                                            label={values.id ? "Mettre à jour" : "Créer l'évènement"}
                                            variant="dark"
                                            type="submit"
                                            disabled={isSubmitting || !stepIsValid(eventCreationStep, values)}
                                            className="submit-button"
                                        />
                                    )}
                                </div>
                            </form>
                        );
                    }}
                </Formik>
            </>
        </Modal>
    );
};
